module.exports = "https://trybtryb-legacy.web.app/img/digital-item.0c83d140.svg";